import type { Deployment } from '../../../../../common/types';
import { getEnvironmentId } from '../../../../../common/utils/deployments';

export const countEnvironments = (deployments: Deployment[]): number => {
	const environmentIds = deployments.map(({ environment }) => getEnvironmentId(environment));
	return new Set(environmentIds).size;
};
